import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../artist-help/styles.css';

const GALLERY_HELP_SECTIONS = [
  { key: 'suarte_features', to: '/profile/gallery-help/suarte-features' },
  { key: 'upload_artworks', to: '/profile/gallery-help/upload-artworks' },
  { key: 'manage_inventory', to: '/profile/gallery-help/manage-inventory' },
  { key: 'artists', to: '/profile/gallery-help/artists' },
  { key: 'admin_mode', to: '/profile/gallery-help/admin-mode' },
  { key: 'limited_editions', to: '/profile/gallery-help/limited-editions' },
  { key: 'commissions', to: '/profile/gallery-help/commissions' },
  { key: 'sell_and_ship', to: '/profile/gallery-help/sell-and-ship' },
  { key: 'account', to: '/profile/gallery-help/account' },
  { key: 'payment_and_invoices', to: '/profile/gallery-help/payment-and-invoices' },
  { key: 'royalties', to: '/profile/gallery-help/royalties' },
  { key: 'subscriptions_vip_studio', to: '/profile/gallery-help/subscriptions-vip-studio' },
];

export default function ProfileGalleryHelp() {
  const t = useTranslations('galleries_help.index');

  return (
    <section className="artist-help-profile gallery-help-profile">
      <header className="artist-help-profile__header gallery-help-profile__header">
        <GoBackButton alternativeRoute="/profile" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-profile__sections gallery-help-profile__sections">
        {GALLERY_HELP_SECTIONS.map((section) => (
          <Link
            key={section.key}
            to={section.to || '/profile/gallery-help'}
            className="artist-help-profile__section artist-help-profile__section--link gallery-help-profile__section gallery-help-profile__section--link"
          >
            <h2>{t(`sections.${section.key}`)}</h2>
          </Link>
        ))}
      </div>
    </section>
  );
}
